export const TEAM_OF_TEAMS = 'TEAM_OF_TEAMS';
export const TEAM_OF_USERS = 'TEAM_OF_USERS';

export enum TeamType {
    TEAM_OF_USERS = 'TEAM_OF_USERS',
    TEAM_OF_TEAMS = 'TEAM_OF_TEAMS',
}
